import React from 'react'
import StyledText from '../../../components/StyledComponents/StyledText'
import { useTheme } from '../../../middleware/ThemeContext';
import styled from 'styled-components';
import { CheckCircle } from '@mui/icons-material';

interface FontPicker {
    inputName: string;
    fontName: string;
    selected?: boolean;        // 👈 Add this
    onClick?: () => void;      // 👈 Add this
    isResponsive?: boolean
}

const FontPicker: React.FC<FontPicker> = ({ inputName, fontName, selected = false, onClick, isResponsive }) => {
    const { theme } = useTheme();
    return (
        <FontPickerCon theme={theme} className='col' >
            <input type='radio' name={inputName} checked={selected} onChange={onClick} style={{ display: 'none' }} />
            <span className='input-con' style={{ backgroundColor: theme.CorporateTheme.colors.filterBG, border: `0.5px solid ${theme.CorporateTheme.colors.border}` }} onClick={onClick}>
                <StyledText
                    fontSize={isResponsive ? '22px' : '28px'}
                    fontWeight={400}
                    textColor={theme.CorporateTheme.colors.textSecondary}
                    style={{ marginBottom: '5px' }}
                    fontFamily={
                        fontName === 'Times New Roman' ? 'Times New Roman' :
                            fontName === 'Roboto' ? 'Roboto' :
                                fontName === 'Montserrat' ? 'Montserrat' :
                                    fontName === 'Poppins' ? 'Poppins' : 'Raleway'
                    }
                >
                    Aa123
                </StyledText>
                <StyledText
                    fontSize={isResponsive ? '12px' : '14px'}
                    fontWeight={600}
                    textColor={theme.CorporateTheme.colors.headerColor}
                    fontFamily=''
                >
                    {fontName}
                </StyledText>
                <CheckCircle fontSize={'inherit'}
                    htmlColor={theme.CorporateTheme.colors.blueberry}
                />
            </span>
        </FontPickerCon>
    )
}

export default FontPicker


const FontPickerCon = styled.label`
    position: relative;
    cursor: pointer;
    & input {
        opacity: 0;
        position: absolute;
        left: 0;
    }
    & .input-con {
        display: block;
        border-radius: 5px;
        // min-width: 157px;
        // width: fit-content;
        height: 87px;
        padding: 14px 15px;
        & svg {
            position: absolute;
            top: 5px;
            right: 5px;
            opacity: 0;
        }
    }
    & input:checked ~ .input-con {
        background-color: ${({ theme }) => theme.CorporateTheme.colors.primaryLightBG} !important;
        border-color: ${({ theme }) => theme.CorporateTheme.colors.blueberry} !important;
        & svg {
            opacity: 1;
        }
    }
`;